module.exports = __webpack_public_path__ + "assets/img/Filter.cbfe5de7.svg";